import React from "react"
import { Helmet } from "react-helmet-async"
import { useLanguage } from "@/hooks/useLanguage"

interface SEOProps {
  title?: string
  description?: string
  keywords?: string
  image?: string
  url?: string
}

export const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords,
  image = "/logo_mb_1.jpg",
  url = "https://meatbid.mx",
}) => {
  const { t, language } = useLanguage()

  const siteTitle = title || t.seo.defaultTitle
  const siteDescription = description || t.seo.defaultDesc
  const siteKeywords = keywords || t.seo.keywords

  return (
    <Helmet>
      {/* Standard Metadata */}
      <html lang={language} />
      <title>{siteTitle}</title>
      <meta name="description" content={siteDescription} />
      <meta name="keywords" content={siteKeywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={siteDescription} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  )
}

